import { Component, OnDestroy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PersistanceService } from './services/persistance.service';

import SuperTokens from 'supertokens-web-js';
import Session from 'supertokens-web-js/recipe/session';
import ThirdParty from 'supertokens-web-js/recipe/thirdparty';
import EmailPassword from 'supertokens-web-js/recipe/emailpassword';
import EmailVerification from 'supertokens-web-js/recipe/emailverification';
import { environment } from 'environments/environment';
import { FuseConfigService } from '@fuse/services/config';

SuperTokens.init({
    appInfo: {
        appName: 'Doctra',
        apiDomain: environment.url,
        apiBasePath: '/pstool/supertokens',
    },
    recipeList: [
        Session.init({
            tokenTransferMethod: 'header', // or "cookie"
        }),
        EmailPassword.init(),
        // ThirdParty.init(),
        // EmailVerification.init(),
    ],
});

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet],
})
export class AppComponent {
    colorSchemeMediaQuery: MediaQueryList; // Para cambiar el color del theme dinámicamente
    /**
     * Constructor
     */
    constructor(
        private persistenceSvc: PersistanceService,
        private fuseConfig: FuseConfigService
    ) {}

    ngOnInit(): void {
        // console.log("HIDRATANDO STORE")
        this.persistenceSvc.hidratateStore();
        // Suscribirse a cambios de color scheme
        this.colorSchemeMediaQuery = window.matchMedia(
            '(prefers-color-scheme: dark)'
        );
        this.colorSchemeMediaQuery.addEventListener(
            'change',
            this.handleColorSchemeChange
        );
    }

    ngOnDestroy(): void {
        // console.log(" NGDESTROY : REMOVIENDO LOCAL STORAGE")
        this.persistenceSvc.remove_localStorage();
        if (this.colorSchemeMediaQuery) {
            this.colorSchemeMediaQuery.removeEventListener(
                'change',
                this.handleColorSchemeChange
            );
        }
    }

    private handleColorSchemeChange = (event: MediaQueryListEvent) => {
        this.applyScheme(event.matches);
    };

    private applyScheme(isDark: boolean) {
        environment.scheme = isDark ? 'dark' : 'light';
        this.fuseConfig.config = {
            ...this.fuseConfig.config,
            scheme: environment.scheme,
        };
    }
}
